export const experienceData = [
    {
        id: 1,
        company: 'Deloitte USI',
        jobtitle: 'Associate Analyst',
        startYear: 'Feb 2024',
        endYear: 'Present'
    },
    {
        id: 2,
        company: 'Google Developer Students Club IEM',
        jobtitle: 'WebDev Lead',
        startYear: 'Aug 2022',
        endYear: 'Jul 2023'
    },
    {
        id: 3,
        company: 'IEM Labs',
        jobtitle: 'Backend Developer',
        startYear: 'Feb 2023',
        endYear: 'Mar 2023'
    },
    {
        id: 4,
        company: 'IEM IEDC',
        jobtitle: 'Summer Intern',
        startYear: 'May 2022',
        endYear: 'Nov 2022'
    },
]
